import Header from '../../../__Layout/Header';
import React, { useState } from 'react';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import Loader from '../../../utils/Loader';
import { useStudentFinalQuizSubmitMutation,useGetStudentFinalQuizStartQuery} from "../../../Services/api";
import {pageUrl} from "../../../utils/constants/constants";
import {Link, useParams,useNavigate } from 'react-router-dom';

export default function TakeQuiz() {   
    const {lessionId,courseId,subLessionId,sublessonRserial } = useParams();


    const {
        data: StudentFinalQuiz,
        isLoading: finalLoader,
    } = useGetStudentFinalQuizStartQuery({ pageUrl, params: courseId });
  
  const validationSchema = Yup.object().shape({
    //  quiz: Yup.string().required("Option fields is required"),
  });
  let defaultValues = {};
  const notify = () => '';
  const methods = useForm({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
    defaultValues,
  });
  const [FinalQuizSubmit,isLoading] = useStudentFinalQuizSubmitMutation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;
  const navigator = useNavigate();
  const onSubmit = (values) => {
    
    const quiz={
        'answer':values
         }
    FinalQuizSubmit({ data: quiz })
      .unwrap()
      .then((payload) => {
        if (payload.status==201) {
            navigator(`/free-course-topic-details/${courseId}/${lessionId}/${subLessionId}/${sublessonRserial}`);

          toast.success(payload.message)
        } else {
            alert('please give answer all questions');
           toast.error(payload.message)
        }
      })
      .catch((error) => {
         toast.error(error)
      });
      notify();
  };
     if(finalLoader) return  <Loader></Loader>
   
    return (
            <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">My Courses/Training Quiz</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">My Courses/Training Details</button>
                        </li>
                        <li>
                            <Link to={`/free-course-topic/${courseId}/${lessionId}`} className='btn btn-dark pull-right'>
                              Back
                            </Link>
                        </li>
                       
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                   <div className='col-md-12 col-xs-12 col-sm-12'>
                                   <>
                                     <h1 className='text-center'> Final Quiz</h1>
                                        <form onSubmit={handleSubmit(onSubmit)} >

                                            {StudentFinalQuiz?.data?.data?.map((item,index) => {   
                                                return (                                 
                                                        <>
                                                           
                                                            <p className='m-4'>{index+1} : {item.question_name}</p>
                                                            <div>
                                                            {item?.questions_options?.map((itemQ,index) => {
                                                                return(
                                                                <div key={itemQ.id} className='ml-4'>
                                                                    {index+1} : <input type="radio" {...register(`${item.id}`)} className="option" value={itemQ.id} />&nbsp; &nbsp;
                                                                        <label className="radiocontainer checkedlabel" id="label1">{itemQ.multiple_choice}</label>
                                                                        <span className="text-danger">{errors.quiz?.message}</span>
                                                                </div>)
                                                                                                                                                        
                                                            })}
                                                           
                                                           <input type="hidden" {...register(`exam_id`)}  value={item.exam_id} />
                                                            <input type="hidden" {...register(`course_id`)}  value={item.coursecode} />
                                                            </div>
                                                        </> 
                                                    )  
                                            })  
                                            }
                                            {isLoading.status !='pending' ?                  
                                                 <button className="btn btn-primary ml-4" type="submit" id="confirmBtn">Submit Quiz</button>
                                            :
                                                 <button  className="btn btn-warning ml-4" ><div className="spinner-border text-muted"></div></button>
                                            }
                                        </form>
                                   </>
                                    </div>
                                </div>
                            </section>  
                        </div>
                    </div>
                </div>
            </div>
            </main>
        </div>
    );
}
